// extracted by mini-css-extract-plugin
module.exports = {"cartDropdownLoader":"style_cartDropdownLoader__RRatL"};